

const BASE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://anglaispourvous.fr'

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Anglaispourvous',
  description: 'Anglaispourvous is an English tutoring service offering immersive coaching and 1-on-1 sessions with Marc Herbaut, a native English speaker with 45 years of experience in Canada, now based in St.-Omer, France.',
  url: BASE_URL,
  logo: `${BASE_URL}/assets/images/app_logo.png`,
  sameAs: ['https://linkedin.com/in/marc-herbaut-3b007b8a'],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    email: 'marc@anglaispourvous.fr',
    areaServed: 'FR',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'St.-Omer',
    addressRegion: 'Hauts-de-France',
    addressCountry: 'FR',
  },
}

export const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'English Tutoring with Immersion Method',
  description: 'Learn English through total immersion with Marc Herbaut — 45 years in Canada, 1-on-1 coaching, AI tutoring, and conversation practice.',
  url: BASE_URL,
  dateModified: new Date()?.toISOString()?.split('T')?.[0],
  inLanguage: 'en',
  isPartOf: {
    '@type': 'WebSite',
    name: 'Anglaispourvous',
    url: BASE_URL,
  },
}

export const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'English Tutoring & Coaching',
  description: 'Personalized English tutoring with immersion method, 1-on-1 sessions, AI conversation practice, grammar guide, and dictionary tools.',
  provider: {
    '@type': 'Person',
    name: 'Marc Herbaut',
    url: BASE_URL,
  },
  areaServed: 'FR',
  availableLanguage: ['en', 'fr'],
  serviceType: 'Education',
  offers: [
    {
      '@type': 'Offer',
      name: 'Free Lesson',
      description: 'Complimentary initial consultation',
      price: '0',
      priceCurrency: 'EUR',
    },
    {
      '@type': 'Offer',
      name: 'Premium AI Plans',
      description: '24/7 AI tutoring, grammar guide, dictionary access',
      priceCurrency: 'EUR',
      url: `${BASE_URL}/ai-plans`,
    },
  ],
}

export const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Anglaispourvous and who is it best for?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Anglaispourvous is an English tutoring service using the total immersion method, designed for French speakers who want to learn English through real-world conversation and coaching. It is best for professionals, students, and anyone seeking personalized 1-on-1 sessions with a native English speaker.',
      },
    },
    {
      '@type': 'Question',
      name: 'What does Anglaispourvous offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Anglaispourvous offers 1-on-1 coaching sessions, 24/7 AI conversation practice, a comprehensive grammar guide, an interactive dictionary, and personalized lesson plans. All services are delivered by Marc Herbaut, who has 45 years of experience living and working in Canada.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does the immersion method work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The immersion method focuses on practical, real-world English through conversation and context. Rather than memorizing grammar rules, students learn by speaking, listening, and engaging in natural dialogue. Marc Herbaut guides each session based on your goals and level, ensuring rapid progress through authentic interaction.',
      },
    },
    {
      '@type': 'Question',
      name: 'How much does Anglaispourvous cost?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Anglaispourvous offers a free initial lesson to assess your level and goals. Premium AI plans start at competitive rates and include unlimited 24/7 access to AI tutoring, grammar tools, and dictionary resources. Visit the pricing page for current rates and package options.',
      },
    },
    {
      '@type': 'Question',
      name: 'What makes Anglaispourvous different from other English tutoring services?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Anglaispourvous combines Marc Herbaut\'s 45 years of real-world English experience in Canada with modern AI tools. The immersion method prioritizes conversation over grammar drills, 1-on-1 personalization over group classes, and practical skills over test preparation. Every student receives customized coaching tailored to their unique goals.',
      },
    },
  ],
}
